import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActionPlanItem } from '../../shared/models/index';

@Component({
    selector: 'responsible-detail',
    templateUrl: './responsible-detail.component.html',
    standalone: false
})
export class ResponsibleDetailComponent implements OnInit {
  @Input() public actionPlanItems: ActionPlanItem[];
  @Output() public toggleSelectItem: EventEmitter<any> = new EventEmitter();
  orderByFieldName = 'priority';
  direction = 'asc';
  @Input() query = '';

  constructor() {}

  ngOnInit() {}

  public openActionPlanItem(item: ActionPlanItem) {
    this.toggleSelectItem.emit(item);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
